module.exports = __webpack_public_path__ + "img/image10.0a10d3d8.png";